var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"weixin-tip"},[_c('p',[_c('img',{attrs:{"src":require("../assets/位图@2x.png"),"alt":"微信打开"}})])]),_c('div',{staticClass:"box"},[_c('div',{staticClass:"box_zt"},[_c('div',{staticClass:"box_yun"},[_c('button',{staticClass:"box_btn"},[_vm._v("下载APP")])])])])])
}]

export { render, staticRenderFns }